import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerServiceWorkerForProd } from './utils/swUpdate';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// In dev (`react-scripts start`), a service worker causes aggressive caching and makes changes
// appear "stuck". Only register the PWA service worker in production builds.
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    registerServiceWorkerForProd();
  } else {
    // Make sure no SW is controlling localhost:3000 after experiments / previous builds.
    navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
  }
}

// Detect if app is running as PWA
declare global {
  interface Window {
    isInstalledPWA?: boolean;
  }
}

if (window.matchMedia('(display-mode: standalone)').matches) {
  window.isInstalledPWA = true;
}

// beforeinstallprompt is handled in PWAInstallButton (must call .prompt() after preventDefault)
